export default __webpack_public_path__ + "static/service_04-5a4842eca21d7d8a2fc66e73fc246f37.jpg";